<script setup lang="ts">
import { computed } from 'vue'
import { RouterView, useRoute } from 'vue-router'

defineOptions({ name: 'MemberH5App' })
const route = useRoute()
const legacyPointsLayout = computed(() => ['member-points', 'member-points-product-detail', 'member-points-orders'].includes(String(route.name)))
</script>

<template>
  <div class="app-shell" :class="{ 'app-shell--legacy-points': legacyPointsLayout }">
    <RouterView />
  </div>
</template>

<style scoped>
.app-shell--legacy-points { max-width: 750px; }
</style>
